import dchAPI from '@/services/dchAPI';

const state = {
  currentFetchRequests: [],
  fetchRequestsList: [],
  fetchRequestsCursor: null,
  selectedFetchRequest: null,
};

const getters = {
  currentFetchRequests: (state) => state.currentFetchRequests,
  fetchRequestsList: (state) => state.fetchRequestsList,
  fetchRequestsCursor: (state) => state.fetchRequestsCursor,
  selectedFetchRequest: (state) => state.selectedFetchRequest,
};

const actions = {
  async refetchData({ commit }, model) {
    const requestBody = {
      source_handle: model.source_handle,
      start: model.start_time,
      end: model.end_time,
      asset_ids: model.assets.map((asset) => asset.asset_id),
    };

    const response = await dchAPI.post('data/fetch', requestBody);
    commit('setCurrentFetchRequests', response.data.data);
    return response;
  },

  async pollByFetchId({ commit }, fetchId) {
    const response = await dchAPI.get(`data/fetch/${fetchId}`);
    commit('setCurrentFetchRequest', response.data.data);
    return response;
  },

  async fetchRequestSummary({ commit }, model) {
    // start=2023-01-01T00%3A00%3A00&end=2024-01-09T06%3A18%3A00&interval=monthly
    const params = {
      interval: model.interval,
      start: model.start_time,
      end: model.end_time,
    };
    if (model.asset_id != null) {
      params.asset_id = model.asset_id;
    }
    if (model.source_handle != null) {
      params.source = model.source_handle;
    }
    const response = await dchAPI.get('data/fetch/summary', { params: params });
    commit('setFetchRequestSummary', response.data.data);
    return response;
  },

  async listFetchRequests({ commit }, { source, asset_id, limit = 5, cursor = null, append = false, files_only = false }) {
    const params = { limit };
    if (source) params.source = source;
    if (asset_id) params.asset_id = asset_id;
    if (cursor) params.cursor = cursor;
    if (files_only) params.files_only = files_only;
    params.include_files = true;

    const response = await dchAPI.get('data/fetch', { params });
    commit('setFetchRequestsList', { data: response.data.data, cursor: response.data.meta?.cursor, append });
    return response;
  },

  async getFetchRequestDetails({ commit }, fetchId) {
    const params = { include_files: true, include_status_log: true };
    
    const response = await dchAPI.get(`data/fetch/${fetchId}`, { params });
    commit('setSelectedFetchRequest', response.data.data);
    return response;
  },

  async runTask({ commit }, { task_id, run_async }) {
    const response = await dchAPI.post('tasks/runs', {
      task_id,
      run_async,
    });
    return response;
  },
};

const mutations = {
  setCurrentFetchRequests: (state, fetchRequests) => {
    state.currentFetchRequests = fetchRequests;
  },
  setCurrentFetchRequest: (state, fetchRequest) => {
    const index = state.currentFetchRequests.findIndex(
      (req) => req.fetch_id === fetchRequest.fetch_id
    );
    if (index > -1) {
      state.currentFetchRequests[index] = fetchRequest;
    }
  },
  setFetchRequestSummary: (state, fetchRequestSummary) => {
    state.fetchRequestSummary = fetchRequestSummary;
  },
  setFetchRequestsList: (state, { data, cursor, append }) => {
    if (append) {
      state.fetchRequestsList = [...state.fetchRequestsList, ...data];
    } else {
      state.fetchRequestsList = data;
    }
    state.fetchRequestsCursor = cursor;
  },
  setSelectedFetchRequest: (state, fetchRequest) => {
    state.selectedFetchRequest = fetchRequest;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
